export const UsersParent = (props) => {
  return (
    <div className="max-w-[500px] px-[15px] mx-auto">{props.children}</div>
  );
};
